<app-global-lang-chooser style="position:absolute;top:10px;right:10px;"></app-global-lang-chooser>
<div class="app-background-container">
  <div class="surface-card p-4 shadow-2 border-round w-full lg:w-6 max-w-30rem">
    <form [formGroup]="signUpForm" class="p-fluid" (ngSubmit)="onSignUp()">
      <div class="text-center mb-5">
        <img src="assets/images/app_logo.png" alt="Image" height="20" class="mb-3" />
        <div class="text-900 text-3xl font-medium mb-3">
          {{ 'CREATE_ACCOUNT' | translate }}
        </div>
        <span class="text-600 font-medium line-height-3">
          {{ 'ALREADY_HAVE_ACCOUNT' | translate }}
        </span>
        <a routerLink="/sign-in" class="font-medium ml-2 text-blue-500 cursor-pointer underline">
          {{ 'SIGN_IN' | translate }}
        </a>
      </div>
      <div class="formgrid grid mb-3">
        <div class="field col-6">
          <label for="title" class="block text-900 font-medium mb-2">
            {{ 'TITLE' | translate }}
          </label>

          <p-dropdown formControlName="title" id="title" class="w-full" placeholder="Select a Title"
            [options]="titles" />

          <div *ngIf="
              signUpForm.get('title')?.invalid &&
              signUpForm.get('title')?.touched
            " class="text-red-500 mb-2">
            <small>Title is required.</small>
          </div>
        </div>

        <div class="field col-6">
          <label for="lastName" class="block text-900 font-medium mb-2">
            {{ 'FIRST_NAME' | translate }}
          </label>
          <input pInputText id="firstName" formControlName="firstName" class="w-full" />
          <div *ngIf="
              signUpForm.get('firstName')?.invalid &&
              signUpForm.get('firstName')?.touched
            " class="text-red-500 mb-2">
            <small>{{ 'FIRST_NAME_REQUIRED' | translate }}</small>
          </div>
        </div>
      </div>
      <div class="formgrid grid mb-3">
        <div class="field col-12">
          <label for="lastName" class="block text-900 font-medium mb-2">
            {{ 'LAST_NAME' | translate }}
          </label>
          <input pInputText id="lastName" formControlName="lastName" class="w-full" />
          <div *ngIf="
              signUpForm.get('lastName')?.invalid &&
              signUpForm.get('lastName')?.touched
            " class="text-red-500 mb-2">
            <small>{{ 'LAST_NAME_REQUIRED' | translate }}</small>
          </div>
        </div>
      </div>
      <div class="formgrid grid mb-3">
        <div class="field col-12">
          <label for="email" class="block text-900 font-medium mb-2">
            {{ 'EMAIL' | translate }}
          </label>
          <input pInputText id="email" formControlName="email" class="w-full" />
          <div *ngIf="
              signUpForm.get('email')?.invalid && signUpForm.get('email')?.touched
            " class="text-red-500 mb-2">
            <small *ngIf="signUpForm.get('email')?.errors?.['required']">
              {{ 'EMAIL_REQUIRED' | translate }}
            </small>
            <small *ngIf="signUpForm.get('email')?.errors?.['email']">
              {{ 'INVALID_EMAIL' | translate }}
            </small>
          </div>
        </div>
      </div>
      <div class="formgrid grid mb-3">
        <div class="field col-12">
          <label for="password" class="block text-900 font-medium mb-2">
            {{ 'PASSWORD' | translate }}
          </label>
          <div class="p-inputgroup mb-1">
            <input [type]="passwordVisible ? 'text' : 'password'" pInputText id="password" formControlName="password"
              class="w-full" />
            <span class="p-inputgroup-addon p-0">
              <button type="button" pButton class="p-button-text p-0" (click)="togglePasswordVisibility()" tabindex="-1"
                style="box-shadow: none">
                <i class="pi" [ngClass]="passwordVisible ? 'pi-eye-slash' : 'pi-eye'"></i>
              </button>
            </span>
          </div>
          <div *ngIf="
                  signUpForm.get('password')?.invalid &&
                  signUpForm.get('password')?.touched
                " class="text-red-500 mb-2">
            <small *ngIf="signUpForm.get('password')?.errors?.['pattern']">
              {{ 'PASSWORD_PATTERN' | translate }}
            </small>
            <small *ngIf="signUpForm.get('password')?.errors?.['required']">
              {{ 'PASSWORD_REQUIRED' | translate }}
            </small>
            <small *ngIf="signUpForm.get('password')?.errors?.['minlength']">
              {{ 'PASSWORD_MINLENGTH' | translate }}
            </small>
          </div>
        </div>
      </div>

      <div class="formgrid grid mb-4">
        <div class="field col-12">
          <label for="confirmPassword" class="block text-900 font-medium mb-2">
            {{ 'CONFIRM_PASSWORD' | translate }}
          </label>
          <div class="p-inputgroup mb-1">
            <input [type]="confirmPasswordVisible ? 'text' : 'password'" pInputText id="confirmPassword"
              formControlName="confirmPassword" class="w-full" />
            <span class="p-inputgroup-addon p-0">
              <button type="button" pButton class="p-button-text p-0" (click)="toggleConfirmPasswordVisibility()"
                tabindex="-1" style="box-shadow: none">
                <i class="pi" [ngClass]="confirmPasswordVisible ? 'pi-eye-slash' : 'pi-eye'"></i>
              </button>
            </span>
          </div>
          <div *ngIf="
                    signUpForm.hasError('mismatch') &&
                    signUpForm.get('confirmPassword')?.touched
                  " class="text-red-500 mb-2">
            <small>{{ 'PASSWORDS_DO_NOT_MATCH' | translate }}</small>
          </div>
        </div>
      </div>
      <button pButton type="submit" [label]="'SIGN_UP' | translate" class="w-full"></button>
    </form>
    <app-consent-dialog *ngIf="showConsentDialog" (consentDialogResult)="onConsentResult($event)"></app-consent-dialog>
  </div>
</div>